var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumBulletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.99297C7.44772 6.99297 7 6.54464 7 5.9916C7 5.43856 7.44772 4.99023 8 4.99023C8.55228 4.99023 9 5.43856 9 5.9916C9 6.54464 8.55228 6.99297 8 6.99297Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.99297C3.44772 6.99297 3 6.54464 3 5.9916C3 5.43856 3.44772 4.99023 4 4.99023C4.55228 4.99023 5 5.43856 5 5.9916C5 6.54464 4.55228 6.99297 4 6.99297Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.00274C10.4477 2.00274 10 1.55441 10 1.00137C10 0.448328 10.4477 0 11 0C11.5523 0 12 0.448328 12 1.00137C12 1.55441 11.5523 2.00274 11 2.00274Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.99938C6.44772 1.99938 6 1.55181 6 0.999691C6 0.447577 6.44772 0 7 0C7.55228 0 8 0.447577 8 0.999691C8 1.55181 7.55228 1.99938 7 1.99938Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12.0008C4.44772 12.0008 4 11.5525 4 10.9994C4 10.4464 4.44772 9.99805 5 9.99805C5.55228 9.99805 6 10.4464 6 10.9994C6 11.5525 5.55228 12.0008 5 12.0008Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12.0008C0.447715 12.0008 0 11.5525 0 10.9994C0 10.4464 0.447715 9.99805 1 9.99805C1.55228 9.99805 2 10.4464 2 10.9994C2 11.5525 1.55228 12.0008 1 12.0008Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.99297C15.4477 6.99297 15 6.54464 15 5.9916C15 5.43856 15.4477 4.99023 16 4.99023C16.5523 4.99023 17 5.43856 17 5.9916C17 6.54464 16.5523 6.99297 16 6.99297Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.99297C11.4477 6.99297 11 6.54464 11 5.9916C11 5.43856 11.4477 4.99023 12 4.99023C12.5523 4.99023 13 5.43856 13 5.9916C13 6.54464 12.5523 6.99297 12 6.99297Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2.00274C18.4477 2.00274 18 1.55441 18 1.00137C18 0.448328 18.4477 0 19 0C19.5523 0 20 0.448328 20 1.00137C20 1.55441 19.5523 2.00274 19 2.00274Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.99938C14.4477 1.99938 14 1.55181 14 0.999691C14 0.447577 14.4477 0 15 0C15.5523 0 16 0.447577 16 0.999691C16 1.55181 15.5523 1.99938 15 1.99938Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12.0008C12.4477 12.0008 12 11.5525 12 10.9994C12 10.4464 12.4477 9.99805 13 9.99805C13.5523 9.99805 14 10.4464 14 10.9994C14 11.5525 13.5523 12.0008 13 12.0008Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12.0008C8.44772 12.0008 8 11.5525 8 10.9994C8 10.4464 8.44772 9.99805 9 9.99805C9.55228 9.99805 10 10.4464 10 10.9994C10 11.5525 9.55228 12.0008 9 12.0008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBulletIcon);
export default __webpack_public_path__ + "static/media/MediumBulletIcon.ed54664dedbe3a194b3fc144a3e72e87.svg";
export { ForwardRef as ReactComponent };